import { SEGMENT_TOKEN } from '../../config';
import { reduxHandlers } from './reduxTrackers';

/**
 * Loads the Segment library: the body of the function is taken from
 * https://segment.com/docs/sources/website/analytics.js/quickstart/
 */
export const loadSegment = () => {
	/* eslint-disable no-console */
	(function () {
		/*
		COPY-PASTE NON-MINIFIED SEGMENT SNIPPET (START)
		https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
		*/

		// Create a queue, but don't obliterate an existing one!
		var analytics = window.analytics = window.analytics || [];

		// If the real analytics.js is already on the page return.
		if (analytics.initialize) return;

		// If the snippet was invoked already show an error.
		if (analytics.invoked) {
			if (window.console && console.error) {
				console.error('Segment snippet included twice.');
			}
			return;
		}

		// Invoked flag, to make sure the snippet
		// is never invoked twice.
		analytics.invoked = true;

		// A list of the methods in Analytics.js to stub.
		analytics.methods = [
			'trackSubmit',
			'trackClick',
			'trackLink',
			'trackForm',
			'pageview',
			'identify',
			'reset',
			'group',
			'track',
			'ready',
			'alias',
			'debug',
			'page',
			'once',
			'off',
			'on',
			'addSourceMiddleware',
			'addIntegrationMiddleware',
			'setAnonymousId',
			'addDestinationMiddleware'
		];

		// Define a factory to create stubs. These are placeholders
		// for methods in Analytics.js so that you never have to wait
		// for it to load to actually record data. The `method` is
		// stored as the first argument, so we can replay the data.
		analytics.factory = function (method) {
			return function () {
				var args = Array.prototype.slice.call(arguments);
				args.unshift(method);
				analytics.push(args);
				return analytics;
			};
		};

		// For each of our methods, generate a queueing stub.
		for (var i = 0; i < analytics.methods.length; i++) {
			var key = analytics.methods[i];
			analytics[key] = analytics.factory(key);
		}

		// Define a method to load Analytics.js from our CDN,
		// and that will be sure to only ever load it once.
		analytics.load = function (key, options) {
			// Create an async script element based on your key.
			var script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.src = 'https://cdn.segment.com/analytics.js/v1/'
				+ key + '/analytics.min.js';

			// Insert our script next to the first script element.
			var first = document.getElementsByTagName('script')[0];
			first.parentNode.insertBefore(script, first);
			analytics._loadOptions = options;
		};

		analytics._writeKey = SEGMENT_TOKEN;

		// Add a version to keep track of what's in the wild.
		analytics.SNIPPET_VERSION = '4.15.3';

		// Load Analytics.js with your key, which will automatically
		// load the tools you've enabled for your account. Boosh!
		analytics.load(SEGMENT_TOKEN);

		// Make the first page call to load the integrations. If
		// you'd like to manually name or tag the page, edit or
		// move this call however you'd like.
		analytics.page();

		/* COPY-PASTE NON-MINIFIED SEGMENT SNIPPET (END) */
	})();
	/* eslint-enable no-console */

	if (process.env.NODE_ENV === 'development') {

		// Add some logging to Segment's identify and track methods to facilitate inspection and debugging
		window.analytics.ready(() => {

			let actualIdentify = window.analytics.identify;
			window.analytics.identify = (...args) => {
				console.log('[Segment] identify', args); // eslint-disable-line
				actualIdentify.apply(this, args);
			};

			let actualTrack = window.analytics.track;
			window.analytics.track = (...args) => {
				console.log('[Segment] track', args); // eslint-disable-line
				actualTrack.apply(this, args);
			};

		});

	}

};

/**
 * Tracks a Redux action with Segment, if an handler for that action is specified in actionHandlers
 * @param {*} action
 */
export const trackAction = (action) => {
	reduxHandlers[action.type] && reduxHandlers[action.type](action);
};


// WEBPACK FOOTER //
// ./src/lib/Segment/index.js